import React, { useState, useEffect } from "react";
import axios from "axios";
import Swal from "sweetalert2";

const ListaApartamentos = () => {
  const [apartamentos, setApartamentos] = useState([]);
  const [nuevoApartamento, setNuevoApartamento] = useState({
    nombre: "",
    color: "#FF5733",
  });

  // Función para sanitizar la entrada de texto, convirtiendo caracteres especiales a texto plano
  const sanitizeInput = (input) => {
    const tempElement = document.createElement("div"); // Crear un elemento temporal
    tempElement.textContent = input; // Establecer el texto del input como contenido
    return tempElement.innerHTML; // Devolver el contenido como texto plano
  };

  // Cargar apartamentos desde el backend
  const cargarApartamentos = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}/apartamentos`
      );
      setApartamentos(response.data);
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Error al cargar los apartamentos",
      });
      console.error("Error al cargar los apartamentos:", error);
    }
  };

  useEffect(() => {
    cargarApartamentos();
  }, []);

  // Manejo de cambios en el formulario de nuevo apartamento
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setNuevoApartamento({ ...nuevoApartamento, [name]: sanitizeInput(value) }); // Sanitizar el valor de entrada
  };

  // Crear un nuevo apartamento
  const crearApartamento = async (e) => {
    e.preventDefault();

    // Validación del nombre
    if (nuevoApartamento.nombre.length > 50) {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "El nombre del apartamento no puede exceder los 50 caracteres.",
      });
      return;
    }

    try {
      await axios.post(
        `${process.env.REACT_APP_API_URL}/apartamentos`,
        nuevoApartamento,
        {
          headers: { "Content-Type": "application/json" },
        }
      );

      // Limpiar el formulario
      setNuevoApartamento({ nombre: "", color: "#FF5733" });

      // Mostrar mensaje de éxito y recargar la lista de apartamentos
      Swal.fire({
        icon: "success",
        title: "Éxito",
        text: "Apartamento creado con éxito.",
      }).then(() => {
        cargarApartamentos();
      });
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "No se pudo crear el apartamento.",
      });
      console.error("Error al crear el apartamento:", error);
    }
  };

  // Eliminar un apartamento con confirmación
  const eliminarApartamento = async (id) => {
    const result = await Swal.fire({
      title: "¿Estás seguro?",
      text: "No podrás revertir esta acción.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Sí, eliminar",
      cancelButtonText: "Cancelar",
    });

    if (result.isConfirmed) {
      try {
        await axios.delete(`${process.env.REACT_APP_API_URL}/apartamentos/${id}`);
        Swal.fire({
          icon: "success",
          title: "Eliminado",
          text: "Apartamento eliminado con éxito.",
        });
        cargarApartamentos();
      } catch (error) {
        Swal.fire({
          icon: "error",
          title: "Error",
          text: "No se pudo eliminar el apartamento.",
        });
        console.error("Error al eliminar el apartamento:", error);
      }
    }
  };

  return (
    <section className="min-h-screen p-4 md:p-8 bg-gray-100">
      <div className="w-full max-w-2xl md:max-w-4xl mx-auto bg-white p-4 md:p-8 rounded-lg shadow-lg">
        <h2 className="text-2xl md:text-3xl font-bold text-gray-800 mb-4 md:mb-6 text-center">
          Lista de Apartamentos
        </h2>

        {/* Formulario para crear apartamento */}
        <form onSubmit={crearApartamento} className="mb-4 md:mb-6 space-y-4">
          <div>
            <label className="block text-gray-700">
              Nombre del Apartamento
            </label>
            <input
              type="text"
              name="nombre"
              value={nuevoApartamento.nombre}
              onChange={handleInputChange}
              required
              className="border p-2 rounded-md w-full text-sm md:text-base"
            />
          </div>
          <div>
            <label className="block text-gray-700">Color del Apartamento</label>
            <input
              type="color"
              name="color"
              value={nuevoApartamento.color}
              onChange={handleInputChange}
              required
              className="border p-2 rounded-md w-full text-sm md:text-base"
            />
          </div>
          <button
            type="submit"
            className="bg-blue-500 text-white p-2 rounded w-full md:w-auto hover:bg-blue-600"
          >
            Crear Apartamento
          </button>
        </form>

        {/* Lista de apartamentos */}
        <h3 className="text-lg md:text-xl font-semibold text-gray-700 mb-2 md:mb-4">
          Apartamentos Existentes
        </h3>
        <ul className="space-y-2">
          {apartamentos.map((apto) => (
            <li
              key={apto.id}
              className="border-b py-2 flex flex-col md:flex-row md:justify-between md:items-center"
            >
              <span className="font-semibold">{apto.nombre}</span>
              <span className="text-sm">
                Color: <span style={{ color: apto.color }}>{apto.color}</span>
              </span>
              <button
                onClick={() => eliminarApartamento(apto.id)}
                className="bg-red-500 text-white p-1 mt-2 md:mt-0 rounded hover:bg-red-600"
              >
                Eliminar
              </button>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
};

export default ListaApartamentos;
